import transcodingStatuses from 'shared/constants/transcoding-statuses';
import uploadingStatuses from 'shared/constants/uploading-statuses';
import uploadErrorTypes from 'shared/constants/upload-error-types';
import dashboardConstants from 'shared/constants/dashboard';


const TRANSCODING_PROGRESS_STATUSES = [
  transcodingStatuses.IN_QUEUE,
  transcodingStatuses.PENDING,
  transcodingStatuses.INPROGRESS,
  transcodingStatuses.PREVIEW_READY,
];


export function isCancelled(videoData) {
  return _.get(videoData, 'error.code') === dashboardConstants.UPLOADING_CANCEL_CODE;
}

export function isFake({ id }) {
  return /FAKE/.test(id);
}

export function canCancelUpload({ uploadingStatus }) {
  return _.includes([uploadingStatuses.WAITING, uploadingStatuses.UPLOADING], uploadingStatus);
}

export function isUploadFailed({ transcodingStatus, uploadingStatus }) {
  return (!uploadingStatus && transcodingStatus === transcodingStatuses.NONE) ||
    uploadingStatus === uploadingStatuses.FAILED;
}

export function isTranscodingFailed({ transcodingStatus }) {
  return transcodingStatus === transcodingStatuses.FAILED;
}

export function isTranscoded({ transcodingStatus }) {
  return transcodingStatus === transcodingStatuses.READY;
}

export function isUploaded({ transcodingStatus, uploadingStatus }) {
  return uploadingStatus === uploadingStatuses.SUCCEEDED ||
    (!uploadingStatus && transcodingStatus && transcodingStatus !== transcodingStatuses.NONE);
}

export function isFailed(videoData) {
  return isUploadFailed(videoData) || isTranscodingFailed(videoData);
}

export function isQuotaExceeded(videoData) {
  return isFailed(videoData) && isQuotaExceededByError(_.get(videoData, 'error'));
}

export function isQuotaExceededByError(error) {
  return _.get(error, 'data.errorInfo.key') === uploadErrorTypes.QUOTA_EXCEEDED;
}

export function isInTranscoding({ transcodingStatus }) {
  return _.includes(TRANSCODING_PROGRESS_STATUSES, transcodingStatus);
}

export const UPLOAD_ERROR_TYPES = {
  FAILED: 'failed',
  QUOTA_EXCEEDED: 'quota_exceeded',
};

export function getUploadErrorType(error) {
  if (isQuotaExceededByError(error)) {
    return UPLOAD_ERROR_TYPES.QUOTA_EXCEEDED;
  }
  return UPLOAD_ERROR_TYPES.FAILED;
}



// WEBPACK FOOTER //
// ./src/shared/utils/video-helpers/statuses.js